import { NAMED_ANSWERS } from './constants';

import type { FormValues } from '$lib/types/Form';

export const transformNamedAnswers = (namedAnswers: FormValues): FormValues => {
    const { fname, lname, firstName, lastName, ...rest } = namedAnswers;

    return {
        ...(firstName ? { firstName } : fname ? { firstName: fname } : {}),
        ...(lastName ? { lastName } : lname ? { lastName: lname } : {}),
        ...rest,
    };
};

interface MergeTrackingPropertiesParams {
    allTrackingProperties: FormValues;
    namedAnswers: FormValues;
    maxTrackingProperties: number;
}

const MAX_TRACKING_PROPERTIES = 10;

/***
 * Merges tracking properties from previous pages into named answers
 */
export const mergeTrackingProperties = (params: MergeTrackingPropertiesParams): FormValues => {
    const { allTrackingProperties, namedAnswers, maxTrackingProperties } = params;

    const updatedNamedAnswers = { ...namedAnswers };
    let processedCount = maxTrackingProperties;

    Object.entries(allTrackingProperties).forEach(([name, value]) => {
        const answerAlreadyAddedBefore = Object.keys(updatedNamedAnswers).includes(name);

        const exceedsLimit = processedCount >= MAX_TRACKING_PROPERTIES;

        if (answerAlreadyAddedBefore || name.startsWith('utm_') || exceedsLimit) {
            // don't overwrite the phone or email when it is set in the Form
            // don't add utm_ properties to the named answers (they go in UTM params)
            // don't process more than MAX_TRACKING_PROPERTIES from previous pages
            return;
        }

        if (NAMED_ANSWERS.includes(name)) {
            updatedNamedAnswers[name] = value;
            processedCount += 1;
        }
    });

    return updatedNamedAnswers;
};
